import axios, { AxiosResponse } from 'axios'

const includes = ['department']

export const getSettings = (): Promise<AxiosResponse> => axios.get(`${process.env.REACT_APP_API_URL}/settings`,
    {
        params: {
            include: includes.join(','),
        },
    })
